import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";

const LoadingWithLabel = ({ progress }) => {
  return (
    <Fade in={true} timeout={800}>
    <Box
      sx={{
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 15,
        borderRadius: "16px",
      }}
    >
      {/* 原本的 CircularProgress 區塊，保持 relative 以便內部文字絕對定位 */}
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          enableTrackSlot
          variant="determinate"
          value={progress}
          size="5rem"
          thickness={2.5}
          color="success"
        />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            component="div"
            sx={{
              color: "text.secondary",
              fontSize: "1.5rem",
            }}
          >
            {progress}%
          </Typography>
        </Box>
      </Box>
    </Box>
    </Fade>
  );
};

export default LoadingWithLabel;
